
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/machine-learning-development-services",
      function () {
        return require("private-next-pages/machine-learning-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/machine-learning-development-services"])
      });
    }
  